<template>
  <div class="auth-phone">
    <p class="auth-phone__label">
      {{ label }}<span v-if="required" class="auth-phone__required">*</span>
    </p>
    <div class="auth-phone__row">
      <v-select
        class="auth-phone__code general-select-border"
        :clearable="false"
        :options="countries"
        :value="dialCode"
        label="dial_code"
        @input="$emit('update:dialCode', $event)">
        <template #option="{ dial_code, code }">
          <span class="body-2 mb-0">{{ code }} </span>|<span class="body-2 text-color-dark"> {{ dial_code }}</span>
        </template>
      </v-select>
      <input
        class="auth-phone__number"
        :class="{ 'is-invalid': !!error }"
        type="tel"
        inputmode="tel"
        autocomplete="tel"
        :placeholder="placeholder"
        :value="number"
        @input="$emit('update:number', $event.target.value)" />
    </div>
    <p v-if="error" class="auth-phone__error">{{ error }}</p>
  </div>
</template>

<script>
  import country from '@/data/country';

  export default {
    name: 'AuthPhoneField',
    props: {
      dialCode: {
        type: Object,
        default: () => ({})
      },
      number: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      error: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        countries: country
      }
    }
  }
</script>

<style scoped>
.auth-phone {
  margin-bottom: 16px;
}
.auth-phone__label {
  margin: 0 0 6px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #1C2B36;
}
.auth-phone__required {
  margin-left: 2px;
  color: #D92D20;
}
.auth-phone__row {
  display: grid;
  grid-template-columns: 116px 1fr;
  gap: 8px;
}
.auth-phone__number {
  width: 100%;
  padding: 12px 14px;
  font-size: 0.9375rem;
  color: #1C2B36;
  background: #fff;
  border: 1px solid #E0E8EF;
  border-radius: 12px;
  outline: none;
}
.auth-phone__number:focus {
  border-color: var(--merchant-primary-color, #1AA179);
  box-shadow: 0 0 0 3px var(--merchant-primary-color-alpha-15, rgba(26, 161, 121, 0.15));
}
.auth-phone__number.is-invalid {
  border-color: #D92D20;
}
.auth-phone__error {
  margin: 6px 0 0;
  font-size: 0.75rem;
  color: #D92D20;
}
.auth-phone__code >>> .vs__dropdown-toggle {
  min-height: 46px;
  border-radius: 12px;
  border-color: #E0E8EF;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/AuthPhoneField.vue